/**
 * Fixed Conclusion text for an inconclusive attribute test. The model's own L1
 * is free prose written in the same pass as the outcome, so on an inconclusive
 * result it can still assert "passed"; this message is always true instead.
 */
export const INCONCLUSIVE_CONCLUSION_MESSAGE =
  "Midship couldn't reach a verdict from the available evidence. Add supporting documents or refine the test instructions, then run the test again.";

export type TrailConclusionDisplay =
  | {
      kind: "inconclusive";
      message: string;
      editable: false;
    }
  | { kind: "authored"; text: string; editable: true }
  | { kind: "empty"; editable: true };

interface TrailConclusionInput {
  inconclusive: boolean;
  l1: string;
}

/**
 * Decide what the Workpaper Review "Conclusion" block shows:
 * - inconclusive → the fixed message, not editable;
 * - conclusive with an L1 → that L1, editable;
 * - conclusive with a blank L1 (e.g. just overridden from inconclusive) →
 *   an empty state prompting the auditor to write one.
 */
export function getTrailConclusionDisplay({
  inconclusive,
  l1,
}: TrailConclusionInput): TrailConclusionDisplay {
  if (inconclusive) {
    return {
      kind: "inconclusive",
      message: INCONCLUSIVE_CONCLUSION_MESSAGE,
      editable: false,
    };
  }
  const text = l1.trim();
  if (text.length === 0) {
    return { kind: "empty", editable: true };
  }
  return { kind: "authored", text, editable: true };
}
